<template>
	<div class="chatroomError">暂无权限</div>
</template>
<script>
export default {
	name: '403',
	props: [],
	data() {
		return {}
	},
	methods: {}
}
</script>
<style scoped>
.chatroomError {
	font-size: 24px;
	text-align: center;
	margin-top: 10%;
	font-weight: 700;
}
</style>


// WEBPACK FOOTER //
// src/components/errorPage/403.vue